<template>
  <span>
      <div class="layout-wrapper">
          <div class="header-top">
              <div @click.stop="toggleDepartmets()" class="nav-icon">
                  <img src="/img/nav_menu.svg" class="img-icon" />
              </div>

              <div class="mob-logo-wrp">
                  <div class="logo-box">
                      <router-link :to="{ name: 'Home' }" class="logo_box_link">
                          <img src="/img/logo_icon.svg" class="logo-icon">
                      </router-link>
                      <router-link :to="{ name: 'Home' }" class="logo_box_link">
                          <img src="/img/logo_txt.svg" class="full-logo">
                      </router-link>
                  </div>
                  <div class="mob-logo-txt-wrp">
                      <p class="mob-logo-txt">Powered by</p>
                      <p class="mob-logo-txt">Eichlers of Boro Park</p>
                  </div>
              </div>

              <bag-icon />

          </div>
          <div class="header-bottom">
              <div @click="openSearch()" class="search-box-wrapper">
                  <img src="/img/mobile_search.svg" class="search-icon" />
                  <div class="search-term">{{ mobSearchElm.searchInput || 'Search' }}</div>
              </div>
          </div>
          <categories-list ref="categories-list"></categories-list>
      </div>
      <div class="shipping">
          <div>ShopEichlers.com</div>

          <div v-if="freeShipping" class="free-wrap" @click.stop="shippingTerms()">
              <div class="free-devider">|</div>
              <div>Free Shipping over {{ '$' + freeShipping }}</div>
              <img src="/img/np_arrow.svg" />

              <shipping-terms ref="shippingTerms" />
          </div>
          <div v-else class="free-wrap" @click.stop="shippingTerms()">
              <div class="free-devider">|</div>
              <div>Free Shipping on all orders</div>
              <img src="/img/np_arrow.svg" />

              <shipping-terms ref="shippingTerms" />
          </div>

      </div>
      <mobile-search ref="mobileSearch" />
  </span>
</template>

<script>
import BagIcon from '../bag/BagIcon'
import MobileSearch from './MobileSearch'
import ShippingTerms from '../partials/ShippingTerms'
import CategoriesList from '../categories/CategoriesList'
import { mapGetters } from 'vuex'
export default {

  data() {
      return {
          mobSearchElm: {}
      }
  },

  computed: {
      ...mapGetters({
          freeShipping: 'shippingRates/freeShipping',
      }),
  },

  methods: {
      toggleDepartmets() {
          this.$refs["categories-list"].toggleVisibility();
      },
      openSearch() {
          this.mobSearchElm.open()
      },
      shippingTerms() {
          this.$refs.shippingTerms.open()
      }
  },

  mounted() {
      this.mobSearchElm = this.$refs.mobileSearch
  },

  components: {
      BagIcon,
      MobileSearch,
      ShippingTerms,
      CategoriesList
  }
}
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .layout-wrapper {
      background-color: #1D432D;
      padding: 15px;
      background-color: #174834;
      background-image: url(/img/header_pattern.png);
      background-repeat: repeat;
  }

  .header-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
  }

  .nav-icon {
      cursor: pointer;
  }

  .img-icon {
      width: 26px;
      height: 19px;
  }

  .mob-logo-wrp {
      display: flex;
      margin-right: auto;
  }

  .mob-logo-txt-wrp {
      align-self: center;
      margin-left: 7px;
  }

  .mob-logo-txt {
      text-align: left;
      color: #FDFFFE;
      font-size: 8px;
      opacity: .5;
      font-style: italic;
  }

  .logo-box {
      width: 136px;
      height: 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 12px;
  }

  .logo-icon {
      width: 26px;
      height: 25px;
  }

  .full-logo {
      height: 22px;
      width: 100px;
  }

  .search-box-wrapper {
      height: 35px;
      background-color: #FFFFFF;
      border-radius: 1px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
  }

  .search-icon {
      margin-left: 12px;
  }

  .search-term {
      margin-left: 12px;
      font-size: 17px;
      font-weight: 300;
  }

  .shipping {
      width: 100%;
      background-color: #F8EDDC;
      text-align: center;
      font-size: 12px;
      color: black;
      font-weight: 500;
      line-height: 17px;
      padding-top: 6px;
      padding-bottom: 6px;
      border-top: #F9A73D solid 1px;
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .free-wrap {
      display: flex;
      /* align-items: center; */
  }

  .free-wrap img {
      height: 17px;
      width: 9px;
  }

  .free-devider {
      margin-left: 5px;
      margin-right: 5px;
  }

  .free-wrap img {
      margin-left: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/layouts/MobileHeader.vue